<template>
  <ReportLoadingTable v-if="showLoading" />
  <ReportNoData
    v-else-if="!hasTableData"
    :has-filters="hasFilters"
  />
  <AppScrollableTable
    v-else
    :has-fixed-column="hasFixedColumn"
  >
    <slot />
  </AppScrollableTable>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    hasTableData: {
      type: Boolean,
      default: true,
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    hasFixedColumn: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(['showLoading']),
  },
};
</script>
